import { formatPriceWithCommas } from '../../utils/stringUtils';

import Chip from '@mui/material/Chip';

import NotApplicableIcon from '@mui/icons-material/NotInterested';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import PartiallyPaidIcon from '@mui/icons-material/EditCalendar';
import PaidIcon from '@mui/icons-material/Check';
import BlockIcon from '@mui/icons-material/Block';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';


import ListView from '../../Common/Views/ListView';

const InvoicesList = ({
    filters = {},
    addButton = true,
    onSelect = null, // a function to override the table row click action (default is to navigate to details page)
    columns = null, // array if specific columns from the columnsConfig to show in the list view. If null, all columns will be shown.
}) => {

    // Status chip
    const getStatusChip = (status) => {

        const labelMap = {
            'ISSUED': 'Issued',
            'VOID': 'Void',
            'UNCOLLECTABLE': 'Uncollectable'
        };

        const colorMap = {
            'ISSUED': 'success',
            'VOID': 'default',
            'UNCOLLECTABLE': 'error'
        };

        const iconMap = {
            'ISSUED': null,
            'VOID': <BlockIcon fontSize='small' />,
            'UNCOLLECTABLE': <MoneyOffIcon fontSize='small' />
        };

        return <Chip
            label={labelMap[status] || 'Unknown'}
            color={colorMap[status] || 'default'}
            icon={iconMap[status]}
            size='small'
            variant='outlined'
            sx={{ minWidth: '100px' }}
        />;
    };

    // Payment chip
    const getPaymentChip = (status) => {

        const labelMap = {
            'N/A': 'Not applicable',
            'UNPAID': 'Not paid',
            'PARTIALLY_PAID': 'Partially paid',
            'FULLY_PAID': 'Fully Paid'
        };

        const colorMap = {
            'N/A': 'default',
            'UNPAID': 'warning',
            'PARTIALLY_PAID': 'primary',
            'FULLY_PAID': 'success'
        };

        const iconMap = {
            'N/A': <NotApplicableIcon fontSize='small' />,
            'UNPAID': <WarningAmberIcon fontSize='small' />,
            'PARTIALLY_PAID': <PartiallyPaidIcon fontSize='small' />,
            'FULLY_PAID': <PaidIcon fontSize='small' />
        };

        return <Chip
            label={labelMap[status] || 'Unknown'}
            color={colorMap[status] || 'default'}
            onDelete={() => { }}
            deleteIcon={iconMap[status] || <NotApplicableIcon fontSize='small' />}
            size='small'
            variant='outlined'
            sx={{ minWidth: '120px' }}
        />;
    };



    // Columns configuration for rendering location list
    const columnsConfig = {
        invoiceNumber: {
            key: 'invoiceNumber',
            label: 'Invoice #',
            render: row => row.invoiceNumber || 'N/A'
        },
        type: {
            key: 'customerName',
            label: 'Customer name',
            render: row => row.customer?.name || 'Walk-in customer'
        },
        phoneNumber: {
            key: 'customerphoneNumber',
            label: 'Phone number',
            render: row => row.customer?.phoneNumber || 'N/A'
        },
        address: {
            key: 'location',
            label: 'Location',
            render: row => row.location?.name || 'N/A'
        },
        hasOutlet: {
            key: 'netTotal',
            label: 'Total amount',
            render: row => formatPriceWithCommas(row.netTotal)
        },
        status: {
            key: 'status',
            label: 'Status',
            render: row => getStatusChip(row.status)
        },
        paymentStatus: {
            key: 'paymentStatus',
            label: 'Payment status',
            render: row => row.status === 'ISSUED' ? getPaymentChip(row.paymentStatus) : getPaymentChip('N/A')
        },
    };

    return <ListView
        title="Invoices"
        apiPath="/tenants/sales/invoices"
        filters={filters}
        addButton={addButton}
        addButtonLabel="New Invoice"
        addPath="/sales/pos/start"
        rowClickPath={(item) => `/sales/invoices/${item.id}`}
        onSelect={onSelect}
        columnsConfig={columnsConfig}
        columns={columns}
        searchAttributes={[
            { name: "Invoice #", value: "invoiceNumber" },
            { name: "Customer name", value: "customerName" },
            { name: "Phone number", value: "phoneNumber" },
            { name: "Email address", value: "email" },
        ]}
        noResultsMessage="No invoices found"
    />
};

export default InvoicesList;